<div class="modal-content">
    <div class="modal-header">
        <h3>{{'Confirm' | translate}}</h3>
        <div class="modal-close">
            <img class="cross-close" src="/content/icons/Close-Black.svg" (click)="activeModal.close(false)">
        </div>
    </div>
    <div class="modal-body" *ngIf="configuration.isBody">
        {{configuration.body | translate}}
    </div>
    <div class="modal-footer" *ngIf="configuration.isFooter">
        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
            <button mat-stroked-button (click)="activeModal.close(false)">{{configuration.noLabel | translate}}</button>
            <button mat-stroked-button (click)="activeModal.close(true)">{{configuration.yesLabel | translate}}</button>
        </div>
    </div>
</div>
